module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "op-dropdown-select"
  }, [_c('el-dropdown', {
    ref: "opDropdownSelect",
    attrs: {
      "size": "mini",
      "trigger": "click",
      "type": "primary"
    }
  }, [(_vm.type === 'input') ? _c('el-input', {
    attrs: {
      "clearable": _vm.isShow,
      "readonly": true,
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handlerClick($event)
      }
    },
    model: {
      value: (_vm.nameValue),
      callback: function($$v) {
        _vm.nameValue = $$v
      },
      expression: "nameValue"
    }
  }, [(!_vm.disabled) ? _c('template', {
    slot: "append"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleClear($event)
      }
    }
  }, [_vm._v("清除")])], 1) : _vm._e()], 2) : (_vm.type === 'button') ? _c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handlerClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.buttonText))]) : _vm._e(), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "op-dropdown-menu",
    class: {
      active: !_vm.isShow
    },
    attrs: {
      "slot": "dropdown",
      "disabled": _vm.disabled
    },
    slot: "dropdown"
  }, [_c('el-popover', {
    staticClass: "op-dropdown-tips",
    attrs: {
      "placement": "right-start",
      "title": "组织类型图鉴",
      "width": "100",
      "trigger": "hover"
    }
  }, [_vm._l((_vm.tipsList), function(item) {
    return _c('div', {
      key: item.type
    }, [(_vm.iconType === 'image') ? _c('i', {
      staticClass: "op-dropdown-image-icon",
      style: (_vm.handlerIcon(item.type))
    }) : (_vm.iconType === 'class') ? _c('i', {
      staticClass: "iconfont op-dropdown-image-icon",
      class: _vm.handlerIcon(item.type)
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(":  " + _vm._s(item.name))])])
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-warning-outline",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "op-tree-serach",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-input', {
    ref: "focus",
    attrs: {
      "placeholder": "输入关键字进行过滤",
      "autofocus": ""
    },
    on: {
      "input": _vm.filterOnInput
    },
    model: {
      value: (_vm.filterText),
      callback: function($$v) {
        _vm.filterText = $$v
      },
      expression: "filterText"
    }
  })], 1), _vm._v(" "), _c('el-tree', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    ref: "opDropdownTree",
    attrs: {
      "data": _vm.treeDataList,
      "highlight-current": !_vm.multiple,
      "show-checkbox": _vm.multiple,
      "check-strictly": true,
      "expand-on-click-node": false,
      "node-key": "id",
      "default-checked-keys": _vm.defaultCheckedKeys,
      "default-expanded-keys": _vm.defaultCheckedKeys,
      "filter-node-method": _vm.filterNode,
      "props": _vm.treeProps
    },
    on: {
      "node-click": _vm.handleNodeClick,
      "check-change": _vm.handleCheckChange
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var node = ref.node;
        var data = ref.data;

        return _c('span', {}, [(_vm.iconType === 'image') ? _c('i', {
          staticClass: "op-dropdown-image-icon",
          style: (_vm.handlerIcon(data.type))
        }) : (_vm.iconType === 'class') ? _c('i', {
          staticClass: "iconfont op-dropdown-image-icon",
          class: _vm.handlerIcon(data.type)
        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(node.label) + _vm._s(_vm.getLeaveName(data.status)))])])
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ac67945"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrganizationSelect/index.vue
// module id = 2421
// module chunks = 68